/* eslint-disable react/no-unescaped-entities */
import React from "react";

import { Grid } from "@mui/material";
import { useTranslation } from "react-i18next";

import Button, { Color } from "../../../../../../components/Form/Button";
import { Wrapper, UploadIcon, Title, DescriptionContainer, Description } from "./styles";

const defaultIcon = require("Assets/img/empty-state-grid.svg");

type InvoiceEmptySectionProps = {
  onAdd: () => void;
};

export const InvoiceEmptySection: React.FC<InvoiceEmptySectionProps> = (props) => {
  const { onAdd } = props;

  const { t: translate } = useTranslation();

  return (
    <Wrapper
      container
      direction="column"
      alignItems="center"
      justifyContent="center"
      spacing={3}
      data-cy="invoice-maintenance-empty"
    >
      <Grid item xs={12}>
        <img src={defaultIcon} alt="empty state" />
      </Grid>
      <Grid item xs={4}>
        <Title>{translate("itLooksLikeThereSNoDataYet")}</Title>
      </Grid>
      <DescriptionContainer item xs={4}>
        <Description>
          {`${translate("youWillBeAbleToSeeAllTheInformationAboutThe")} ${translate(
            "invoices"
          ).toLocaleLowerCase()} ${translate("associatedWithTheInvoicesWhenYouAddThem")}`}
        </Description>
      </DescriptionContainer>
      <Grid item xs={3}>
        <Button onClick={onAdd} customColor={Color.SECONDARY}>
          <UploadIcon color="#ffffff" size={16} />
          {translate("uploadCsv")}
        </Button>
      </Grid>
    </Wrapper>
  );
};
